module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-duotone-thin-100.woff2";